export enum PermissionType {
  ENTRY = "ENTRY",
  FORM = "FORM",
  KANBAN = "KANBAN",
  KANBAN_CARD = "KANBAN_CARD",
  CONTACT_TASK = "CONTACT_TASK",
  LEAD_TASK = "LEAD_TASK",
  KANBAN_TASK = "KANBAN_TASK",
  ORPHAN_TASK = "ORPHAN_TASK",
}
